export default "__VITE_ASSET__DZX8P02O__"